// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2LMp7","addWidgetButton":"Header_addWidgetButton__3yx5z","dashboardTabs":"Header_dashboardTabs__2AMJW","active":"Header_active__3HDZB"};